/**
 * @generated SignedSource<<8f31e2a4caccc3c523e9aed536941d4f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoGallery_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedInteriorsHeader_itemSearch">;
  readonly " $fragmentType": "SbRespInteriorsPhotoGallery_itemSearch";
};
export type SbRespInteriorsPhotoGallery_itemSearch$key = {
  readonly " $data"?: SbRespInteriorsPhotoGallery_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespInteriorsPhotoGallery_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsPhotoGallery_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsHeader_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "f07b5e762572db307667e2a91206e43e";

export default node;
